import { usePlatformDesigner } from "@/lib/usePlatformDesigner";
import { Navigate } from "react-router-dom";

/** Legacy `/disenador/modulos-comprador` — redirect al Centro de Licencias BNT (Fase 1). */
export default function DesignerModulesHub() {
  const isPlatformDesigner = usePlatformDesigner();
  if (!isPlatformDesigner) {
    return <Navigate to="/disenador/inicio" replace />;
  }
  return <Navigate to="/platform" replace />;
}
